import React, { MutableRefObject, useState } from "react"
import { titleCase } from "../../../utils"
import classNames from "../../../utils/classNames"
import { RefCallBack, UseFormRegister } from "react-hook-form"

const InputFieldWithLabel = ({
  type,
  inputRef,
  label,
  name,
  value,
  defaultValue,
  placeholder,
  disabled,
  readOnly,
  className,
  inputClassName,
  onError,
  onChange,
  onFocus,
  onBlur,
  style,
  full,
  register,
  required,
  min,
  max,
  step,
  error,
  disableArrows,
  autocomplete = "new-password",
  dataTestId,
  prefix,
}: {
  type?: string
  inputRef?: MutableRefObject<any> | RefCallBack
  label?: string
  name?: string
  value?: any
  defaultValue?: any
  placeholder?: string
  disabled?: boolean
  readOnly?: boolean
  className?: string
  inputClassName?: string
  onError?: (err) => any
  onChange?: (e) => any
  onBlur?: (e) => any
  onFocus?: (e) => any
  style?: any
  full?: boolean
  register?: UseFormRegister<any>
  required?: boolean
  min?: number
  max?: number
  step?: string | number
  error?: string
  disableArrows?: boolean
  autocomplete?: string
  dataTestId?: string
  prefix?: string
}) => {
  const [bgColorClass, setBgColorClass] = useState("bg-white")

  return (
    <div className={classNames(full && "w-full transition-opacity duration-300", className, disabled && "opacity-40")}>
      {label && (
        <label
          htmlFor={name || label}
          className={classNames(`block font-semibold text-md text-gray-900 mb-0.5`, error?.length && "text-red-600")}
        >
          {label || titleCase(name)}
          {required && <span className="text-red-600 ml-0.5 relative top-[-0.125rem]">*</span>}
        </label>
      )}
      <div className="relative">
        <input type="text" autoComplete="off" className="hidden"></input>

        {prefix && (
          <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
            <span className="text-gray-500 sm:text-sm">{prefix}</span>
          </div>
        )}

        <input
          ref={inputRef}
          type={type || "text"}
          data-testid={dataTestId}
          value={value}
          placeholder={placeholder}
          min={min}
          max={max}
          autoComplete={autocomplete}
          defaultValue={defaultValue}
          disabled={disabled}
          readOnly={readOnly}
          name={name}
          id={name || label}
          step={step}
          onError={onError}
          required={required}
          onChange={(e) => {
            if (defaultValue !== undefined && e.target.value !== defaultValue) {
              setBgColorClass("bg-blue-50")
            } else {
              setBgColorClass("bg-white")
            }

            if (onChange) onChange(e)
          }}
          onBlur={onBlur}
          onFocus={onFocus}
          style={style}
          className={classNames(
            disableArrows &&
              "[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none",
            prefix ? "pl-8" : "pl-3",
            "block w-full rounded-md border-gray-300 shadow-sm focus:border-green-600 focus:ring-green-600 pr-3",
            bgColorClass,
            inputClassName,
            error?.length && "text-red-600 border-2 border-red-600",
            disabled &&
              "disabled:cursor-not-allowed disabled:border-gray-200 disabled:bg-gray-50 disabled:text-gray-500",
          )}
          {...(register ? register(name, {}) : {})}
        />
      </div>
      {!!error?.length && <span className="text-red-600 font-semibold ml-1 mt-1">{error}</span>}
    </div>
  )
}

export default InputFieldWithLabel
